import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Center from '@/images/position/align/Center.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsCenter } from '../../../../actions/align/Center';

export const CenterMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsCenter(store, selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Center} text="Center" />;
};
